module.exports = __webpack_public_path__ + "img/hc.80aaa93a.svg";